import { motion } from "framer-motion";
import { STUDIO } from "../data";

export const Hero = () => {
  const go = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="top"
      data-testid="hero"
      className="relative min-h-screen flex flex-col justify-end px-6 sm:px-10 pb-16 pt-32 mx-auto max-w-[1600px]"
    >
      <motion.img
        src={STUDIO.logo}
        alt="SO studio"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-[760px] h-auto"
      />

      <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="lg:col-span-6 font-body text-lg sm:text-xl leading-snug text-neutral-800 max-w-xl"
        >
          A photography studio &amp; creative space in central Athens — built
          for shoots, events, workshops, private gatherings and presentations.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.45 }}
          className="lg:col-span-6 lg:col-start-9 flex flex-wrap gap-3"
        >
          <a
            href="#contact"
            onClick={(e) => go(e, "#contact")}
            data-testid="hero-book-btn"
            className="px-7 py-3.5 bg-neutral-900 text-[#FAFAFA] font-body text-sm tracking-wide hover:bg-neutral-700 transition-colors duration-300"
          >
            Book the space
          </a>
          <a
            href="#equipment"
            onClick={(e) => go(e, "#equipment")}
            data-testid="hero-equipment-btn"
            className="px-7 py-3.5 border border-neutral-900 font-body text-sm tracking-wide hover:bg-neutral-900 hover:text-[#FAFAFA] transition-colors duration-300"
          >
            Equipment list
          </a>
        </motion.div>
      </div>
    </section>
  );
};
